import * as Adaptive from "adaptivecards";
import { Input } from "adaptivecards";
import { ChoicePropertyEditor, IVersionedChoice, PropertySheet, PropertySheetCategory, TypedCardElementPeer } from "adaptivecards-designer";
import { removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";
import { getPropertyEditorInstance, PropertyKeys } from "../Pickers/PickerBase";
import { AdaptiveCardTexts, PeoplePicker_UserSourceOptions } from "../../../shared/utils/constants";
import { CardPeoplePickerChoices, renderACPeoplePicker } from "./CardPeoplePicker";

const displayLabelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "displayLabel", true);
const selectionModeProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "selectionMode", true);
const sourceProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "source", true);
const displayChoicesProperty = new Adaptive.EnumProperty(Adaptive.Versions.v1_0, "displayChoices", []);
const requireFieldProperty = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "requireField", false);


export class RequesterPeoplePicker extends Adaptive.TextInput {
  static readonly displayLabelProperty = displayLabelProperty;
  static readonly selectionModeProperty = selectionModeProperty;
  static readonly displayChoicesProperty = displayChoicesProperty;
  static readonly requireFieldProperty = requireFieldProperty;
  static readonly sourceProperty = sourceProperty;
  static readonly JsonTypeName = "Requester";
  static readonly ElementId = "Ticket.Requester";
  static readonly defaultLabel = "Requester";
  static pickerChoices: any[];
  static onCustomValueChange: (input: Input) => void;
  static disableField: boolean;

  //#region Schema

  @Adaptive.property(displayLabelProperty)
  get displayLabel(): string | undefined {
    return this.getValue(RequesterPeoplePicker.displayLabelProperty);
  }

  set displayLabel(value: string | undefined) {
    this.setValue(RequesterPeoplePicker.displayLabelProperty, value);
    this.label = value;
    this.updateLayout();
  }

  @Adaptive.property(selectionModeProperty)
  get selectionMode(): string | undefined {
    return this.getValue(RequesterPeoplePicker.selectionModeProperty);
  }

  set selectionMode(value: string | undefined,) {
    this.setValue(RequesterPeoplePicker.selectionModeProperty, value);
    this.updateLayout();
  }

  @Adaptive.property(sourceProperty)
  get source(): string | undefined {
    return this.getValue(RequesterPeoplePicker.sourceProperty);
  }

  set source(value: string | undefined,) {
    this.setValue(RequesterPeoplePicker.sourceProperty, value);
    this.updateLayout();
  }

  @Adaptive.property(displayChoicesProperty)
  get displayChoices(): any[] | undefined {
    return this.getValue(RequesterPeoplePicker.displayChoicesProperty);
  }

  set displayChoices(value: any[] | undefined,) {
    this.setValue(RequesterPeoplePicker.displayChoicesProperty, value);
    this.updateLayout();
  }

  @Adaptive.property(requireFieldProperty)
  get requireField(): boolean | undefined {
    return this.getValue(RequesterPeoplePicker.requireFieldProperty);
  }

  set requireField(value: boolean | undefined) {
    this.setValue(RequesterPeoplePicker.requireFieldProperty, value);
    this.setValue(RequesterPeoplePicker.isRequiredProperty, value);
    if (value)
      this.setValue(RequesterPeoplePicker.errorMessageProperty, AdaptiveCardTexts.REQUIRE_FIELD);
    this.updateLayout();
  }

  get valueField(): string | undefined {
    return this.getValue(RequesterPeoplePicker.valueProperty);
  }

  set valueField(value: string | undefined) {
    this.setValue(RequesterPeoplePicker.valueProperty, value);
  }

  //#endregion

  protected internalRender(): HTMLElement | undefined {
    this.id = RequesterPeoplePicker.ElementId;
    if ((this?.displayLabel ?? "").length == 0)
      this.displayLabel = RequesterPeoplePicker.defaultLabel;

    if (RequesterPeoplePicker.pickerChoices)
      this.displayChoices = RequesterPeoplePicker.pickerChoices;

    this.selectionMode = "single";

    let source = `${PeoplePicker_UserSourceOptions.EntraMembers}`;
    if ((this?.source ?? "").length == 0)
      this.source = source;
    
    return renderACPeoplePicker(this, RequesterPeoplePicker.onCustomValueChange, RequesterPeoplePicker.disableField);
  }

  get value(): string {
    return this.getValue(RequesterPeoplePicker.valueProperty);
  }

  getJsonTypeName(): string {
    return RequesterPeoplePicker.JsonTypeName;
  }

  updateLayout(processChildren: boolean = true) {
    super.updateLayout(processChildren);
  }
}

export class RequesterPeoplePickerPeer extends TypedCardElementPeer<RequesterPeoplePicker> {
    static displayLabelProperty = getPropertyEditorInstance(RequesterPeoplePicker.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(RequesterPeoplePicker.ElementId, PropertyKeys.requireField);
    static sourceProperty = new ChoicePropertyEditor(Adaptive.Versions.v1_0, "source", "Source", CardPeoplePickerChoices);

    static updateChoices(choices: IVersionedChoice[]) {
      RequesterPeoplePickerPeer.sourceProperty = new ChoicePropertyEditor(Adaptive.Versions.v1_0, "source", "Source", choices);
    }
        
    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
        
        propertySheet.add(
            defaultCategory,
            RequesterPeoplePickerPeer.idProperty,
            RequesterPeoplePickerPeer.displayLabelProperty,
            RequesterPeoplePickerPeer.requireFieldProperty,
            RequesterPeoplePickerPeer.sourceProperty
        );
    
    }
}

